import en from "./en.js";
import cz from "./cz.js";
export default {
  // allowed languages
  languages: ["cz", "en"],
  // currently active language
  currentLang: localStorage.activeLang || "cz",
  // cache of languages loaded from translation files
  translations: {
    cz: cz,
    en: en
  },
  //value used for ng-model in language picker
  selectedLanguage: localStorage.activeLang || "cz",
  // moment's specific language codes
  momentCodes: { cz: "cs", en: "en" },
  getMomentLanguageCode: function() {
    return this.momentCodes[this.currentLang];
  },
  // perform translation
  trans: function(text, replacements) {
    if (typeof this.translations[this.currentLang][text] === "undefined") {
      this.translations[this.currentLang][text] = text;
      console.log("TranslationNotFound:", text);
      localStorage.translations = JSON.stringify(this.translations);
    }
    return this.translations[this.currentLang][text];
  },
  // trigger change of language, reload window with new traslation
  changeLanguage: function() {
    console.log("changing language", this.selectedLanguage);
    if (typeof this.translations[this.selectedLanguage] == "undefined") {
      return;
    }
    localStorage.activeLang = this.selectedLanguage;
    window.location.reload();
  }
};



// WEBPACK FOOTER //
// ./src/Translate/index.js